import React from 'react';
import Particle from './../../Particle';
import {Paragraph, Title, Video} from './../../Basics';

const Particle03 = () => (<div>

  <Title>Aus der Reha an den Cybathlon</Title>
  <Paragraph>
    Der 27-Jährige Florian Hauser ist seit einem Motorradunfall vor zwei Jahren von der
    Brust abwärts gelähmt. Während der Reha im
    Paraplegikerzentrum Nottwil sprach ihn eine Pflegerin an: Ihr Bruder arbeite
    in einem spannenden Projekt der Hochschule Rapperswil. Die suchten einen Piloten
    für das Rollstuhlrennen am Cybathlon. Ob Florian sich das vorstellen könne?
    Er sagte sofort ja. Im Film erzählt er, wie er für den
    Wettkampf trainiert hat und wie für ihn
    der perfekte Rollstuhl aussieht.
  </Paragraph>

  <Video
    source={require('./03_Interview_Florian_Hauser.mp4')}
    poster={require('./03_Interview_Florian_Hauser.png')}
  />

   <Particle
    number={7}
  />

  <Particle
    number={5}
  />

</div>);

export default Particle03;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle03/Particle03.js
 **/